import FullScreenPanel from './FullScreenPanel.jsx';

export default FullScreenPanel;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FullScreenPanel/index.js